import React, { Component } from 'react';

import {
    Button,
    Input,
    Modal,
    Progress
} from 'antd';

import { Api } from '../../lib/api';
import PropTypes from 'prop-types';

class LegacyMigration extends Component {
    static propTypes = {
        legacyMigrationVisible: PropTypes.bool,
        closeLegacyMigration: PropTypes.func.isRequired
    };

    state = {
        mssqlDatabase: '',
        username: '',
        password: '',
        host: '',
        port: '',
        status: null,
        cancelMigrationVisible: false,
        loading: false
    };
    async getStatusMigration() {
        if (
            !(
                this.state.status === 'No migration in progress' ||
                this.state.status === 'Migration cancelled' ||
                this.state.status === 'Migration error' ||
                this.state.status === null
            )
        ) {
            Api.getStatusMigration().then((result) => {
                this.setState({ status: result });
            });
        }
    }

    componentDidMount() {
        Api.getStatusMigration().then((result) => {
            this.setState({ status: result });
        });
        this.intervalId = setInterval(() => this.getStatusMigration(), 3000);
    }

    componentWillUnmount() {
        clearInterval(this.intervalId);
    }

    render() {
        return (
            <Modal
                title={
                    <div className="modal-header">
                        {this.state.status === 'No migration in progress' ||
                        this.state.status === 'Migration cancelled' ||
                        this.state.status === 'Migration error' ||
                        this.state.status === null ? (
                            <div>Authentication </div>
                        ) : (
                            <div>Migrating... </div>
                        )}
                    </div>
                }
                wrapClassName="legacy-import-model"
                open={this.props.legacyMigrationVisible}
                onCancel={() => this.props.closeLegacyMigration({ legacyMigrationVisible: false })}
                closable={true}
                destroyOnClose={true}
                mask={true}
                footer={
                    this.state.status === 'No migration in progress' ||
                    this.state.status === 'Migration cancelled' ||
                    this.state.status === 'Migration error' ||
                    this.state.status === null ? (
                        <Button
                            type="primary"
                            loading={this.state.loading}
                            onClick={() => {
                                this.setState({ loading: true });
                                Api.validateMigration({
                                    mssqlDatabase: this.state.mssqlDatabase,
                                    userName: this.state.username,
                                    password: this.state.password,
                                    host: this.state.host,
                                    port: this.state.port ? this.state.port : '1433',
                                    instanceName: ''
                                }).then((result) => {
                                    if (result === true) {
                                        Api.startMigration({
                                            mssqlDatabase: this.state.mssqlDatabase,
                                            userName: this.state.username,
                                            password: this.state.password,
                                            host: this.state.host,
                                            port: this.state.port,
                                            instanceName: ''
                                        }).then((res) => {
                                            this.setState({ status: res, loading: false });
                                        });
                                    } else {
                                        this.setState({ status: 'Migration error', loading: false });
                                    }
                                });
                            }}
                        >
                            Submit
                        </Button>
                    ) : (
                        <React.Fragment>
                            <Button onClick={() => this.props.closeLegacyMigration({ legacyMigrationVisible: false })}>
                                Close
                            </Button>
                            <Button type="danger" onClick={() => this.setState({ cancelMigrationVisible: true })}>
                                Cancel Migration
                            </Button>
                            <Modal
                                title="Cancel Migration"
                                open={this.state.cancelMigrationVisible}
                                onCancel={() => this.setState({ cancelMigrationVisible: false })}
                                footer={
                                    <div>
                                        <Button
                                            onClick={() =>
                                                Api.cancelMigration().then((result) => {
                                                    this.setState({ status: result, cancelMigrationVisible: false });
                                                })
                                            }
                                            type="primary"
                                        >
                                            Yes
                                        </Button>
                                        <Button onClick={() => this.setState({ cancelMigrationVisible: false })}>No</Button>
                                    </div>
                                }
                            >
                                <div>Are you sure want to cancel migration ?</div>
                            </Modal>
                        </React.Fragment>
                    )
                }
            >
                {this.state.status === 'No migration in progress' ||
                this.state.status === 'Migration cancelled' ||
                this.state.status === 'Migration error' ||
                this.state.status === null ? (
                    <div>
                        {this.state.status === 'Migration error' && <p className="error"> Error : Invalid Input</p>}
                        <div className="title">Username:</div>
                        <Input
                            defaultValue={this.state.username}
                            onChange={(e) => this.setState({ username: e.target.value })}
                        />
                        <div className="title">Password:</div>
                        <Input.Password
                            defaultValue={this.state.password}
                            onChange={(e) => this.setState({ password: e.target.value })}
                        />
                        <div className="title">Database Name:</div>
                        <Input
                            defaultValue={this.state.mssqlDatabase}
                            onChange={(e) => this.setState({ mssqlDatabase: e.target.value })}
                        />
                        <div className="title">Server IP:</div>
                        <Input defaultValue={this.state.host} onChange={(e) => this.setState({ host: e.target.value })} />
                        <div className="title">Port (optional):</div>
                        <Input
                            placeholder="Default port is 1433"
                            defaultValue={this.state.port}
                            onChange={(e) => this.setState({ port: e.target.value })}
                        />
                    </div>
                ) : (
                    <div>
                        <div className="migration-loading-block">
                            <div className="loading">Migration in Process:</div>
                            <Progress type="circle" percent={parseFloat(this.state.status.complete)} />
                            {this.state.status.recordsToProcess && (
                                <div>
                                    {this.state.status.recordsProcessed} out of {this.state.status.recordsToProcess} records
                                    imported
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </Modal>
        );
    }
}

export default LegacyMigration